<template>
    <div class="loading-body" v-show="show">
        <VanLoading vertical>
            <span class="loading-message">{{ loadingMessage }}</span>
        </VanLoading>
    </div>
</template>

<script setup lang="ts">
import Tools from '@/ts/Tools';
import { ref } from 'vue';

const show = ref(false);
const loadingMessage = ref('加载中...');
function Show() {
    show.value = true;
}
function Hide() {
    show.value = false;
}

function SetLoadingMessage(message: string) {
    if (Tools.IsNotNull(message))
        loadingMessage.value = message;
}

defineExpose({
    Show,
    Hide,
    SetLoadingMessage
})
</script>

<style scoped lang="scss">
.loading-body {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 10000;
    background-color: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    .loading-message{
        color: white !important;
    }
}
</style>